import React from "react";
var __jsx = React.createElement;
import { Badge } from "@mantine/core";
var INTENT_CLASSES = {
  base: "bg-sds-base-secondary text-sds-base-secondary border-sds-base-secondary",
  brand: "bg-sds-brand-tertiary text-sds-brand-default border-sds-brand-secondary",
  success: "bg-sds-success-tertiary text-sds-success-secondary border-sds-success-secondary",
  attention: "bg-sds-attention-tertiary text-sds-attention-secondary border-sds-attention-secondary",
  urgent: "bg-sds-urgent-tertiary text-sds-urgent-secondary border-sds-urgent-secondary"
};

/** Small pill showing a status label coloured by semantic intent. */
export function StatusChip(_ref) {
  var intent = _ref.intent,
    label = _ref.label;
  return /*#__PURE__*/React.createElement(Badge, {
    unstyled: true,
    className: "inline-flex w-fit shrink-0 items-center gap-1.5 whitespace-nowrap rounded-sds-full border px-3 py-1 text-style-label-emphasis ".concat(INTENT_CLASSES[intent])
  }, /*#__PURE__*/React.createElement("span", {
    className: "w-1.5 h-1.5 rounded-full bg-current shrink-0"
  }), label);
}